<template>
    <div>
        <br>
        <section>
            <nav className="navbar navbar-inverse sub-navbar fixed-top">
                <div className="container">
                    <div class="col-md-12">
                        <div class="row" style="background: #f6f6f6 !important">
                            <div class="col-md-3 col-md-offset-2">
                                <div className="navbar-header">
                                    <a class="navbar-brand navbar-brand-custom" href="/">SICRE - Consulta Web
                                        <b style="font-size: 9pt !important;">{{version}}</b>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <main class="main">
                <div class="container">
                    <div class="custom-container">
                        <div class="row" v-if="!caseStatusFound">

                            <div class="col-md-24">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="margin-top: 0.5em">
                                            Actor(es)
                                            <span style="color: red">*</span>
                                        </label>
                                        <ul class="nav nav-tabs nav-justified">
                                            <li
                                                    role="presentation"
                                                    :class="applicantTab ? 'active' : ''"
                                                    @click="applicantTab = true; applicantError = null">
                                                <a href="#">Persona</a>
                                            </li>
                                            <li
                                                    role="presentation"
                                                    :class="!applicantTab ? 'active' : ''"
                                                    @click="applicantTab = false; applicantError = null">
                                                <a href="#">Empresa</a>
                                            </li>
                                        </ul>
                                        <div class="row">
                                            <div class="col-md-24">
                                                <div
                                                        v-if="applicantTab"
                                                        class="row"
                                                        style="border: 1px solid #ddd;
													   margin: 0; padding: 0.5em;
													   display: block">
                                                    <div class="row" v-if="applicantError != ''">
                                                        <div class="col-md-24">
                                                            <small style="color: red">{{ applicantError }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="row"
                                                         style="margin: 0; padding: 0 0 0.5em">
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small>
                                                                    <b><i>
                                                                        Nombre(s)
                                                                        <span style="color: red">*</span>
                                                                    </i></b>
                                                                </small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Nombre(s)"
                                                                        v-model="applicantPerson.name">
                                                            </div>
                                                        </div>
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small>
                                                                    <b><i>
                                                                        Primer apellido
                                                                        <span style="color: red">*</span>
                                                                    </i></b>
                                                                </small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Primer apellido"
                                                                        v-model="applicantPerson.firstName">
                                                            </div>
                                                        </div>
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small><b><i>Segundo apellido</i></b></small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Segundo apellido"
                                                                        v-model="applicantPerson.secondName">
                                                            </div>
                                                        </div>
                                                        <button
                                                                class="btn-sm btn-primary"
                                                                type="button"
                                                                style="margin-top: 1em; width: 100%"
                                                                @click="addApplicantPerson">
                                                            Agregar
                                                        </button>
                                                    </div>
                                                </div>
                                                <div
                                                        v-if="!applicantTab"
                                                        class="row"
                                                        style="border: 1px solid #ddd;
													   margin: 0; padding: 0.5em">
                                                    <div class="row" v-if="applicantError != ''">
                                                        <div class="col-md-24">
                                                            <small style="color: red">{{ applicantError }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="row"
                                                         style="margin: 0; padding: 0 0 0.5em">
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small>
                                                                    <b><i>
                                                                        Nombre(s)
                                                                        <span style="color: red">*</span>
                                                                    </i></b>
                                                                </small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Nombre(s)"
                                                                        v-model="applicantCompany.name">
                                                            </div>
                                                        </div>
                                                        <button
                                                                class="btn-sm btn-primary"
                                                                type="button"
                                                                style="margin-top: 1em; width: 100%"
                                                                @click="addApplicantCompany">
                                                            Agregar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row" v-if="applicants != ''">
                                            <div class="col-md-24">
                                                <div class="panel panel-default" style="font-size: 0.8em">
                                                    <div class="panel-heading">Actores</div>
                                                    <table class="table table-striped">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Nombre</th>
                                                            <th class="text-center">Acciones</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(applicant, index) in applicants">
                                                            <th scope="row">{{ index + 1 }}</th>
                                                            <td>
                                                                {{ applicant.name }}
                                                                {{ applicant.firstName != '' ? applicant.firstName : ''
                                                                }}
                                                                {{ applicant.secondName != '' ? applicant.secondName :
                                                                '' }}
                                                            </td>
                                                            <td class="text-center">
													    	<span
                                                                    class="glyphicon glyphicon-trash"
                                                                    aria-hidden="true"
                                                                    style="color: red"
                                                                    @click="removeApplicant(index)">
												    		</span>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--<div class="col-md-6">
                                        <label style="margin-top: 0.5em">
                                            Demandado(s)
                                            <span style="color: red">*</span>
                                        </label>
                                        <ul class="nav nav-tabs nav-justified">
                                            <li
                                                    role="presentation"
                                                    :class="defendantTab ? 'active' : ''"
                                                    @click="defendantTab = true; defendantError = null">
                                                <a href="#">Persona</a>
                                            </li>
                                            <li
                                                    role="presentation"
                                                    :class="!defendantTab ? 'active' : ''"
                                                    @click="defendantTab = false; defendantError = null">
                                                <a href="#">Empresa</a>
                                            </li>
                                        </ul>
                                        <div class="row">
                                            <div class="col-md-24" >
                                                <div
                                                        v-if="defendantTab"
                                                        class="row"
                                                        style="border: 1px solid #ddd;
                                                       margin: 0; padding: 0.5em;
                                                       display: block">
                                                    <div class="row" v-if="defendantError != ''">
                                                        <div class="col-md-24">
                                                            <small style="color: red">{{ defendantError }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="row"
                                                         style="margin: 0; padding: 0 0 0.5em">
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small>
                                                                    <b><i>
                                                                        Nombre(s)
                                                                        <span style="color: red">*</span>
                                                                    </i></b>
                                                                </small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Nombre(s)"
                                                                        v-model="defendantPerson.name">
                                                            </div>
                                                        </div>
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small>
                                                                    <b><i>
                                                                        Primer apellido
                                                                        <span style="color: red">*</span>
                                                                    </i></b>
                                                                </small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Primer apellido"
                                                                        v-model="defendantPerson.firstName">
                                                            </div>
                                                        </div>
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small><b><i>Segundo apellido</i></b></small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Segundo apellido"
                                                                        v-model="defendantPerson.secondName">
                                                            </div>
                                                        </div>
                                                        <button
                                                                class="btn-sm btn-primary"
                                                                type="button"
                                                                style="margin-top: 1em; width: 100%"
                                                                @click="addDefendantPerson">
                                                            Agregar
                                                        </button>
                                                    </div>
                                                </div>
                                                <div
                                                        v-if="!defendantTab"
                                                        class="row"
                                                        style="border: 1px solid #ddd;
                                                       margin: 0; padding: 0.5em">
                                                    <div class="row" v-if="defendantError != ''">
                                                        <div class="col-md-24">
                                                            <small style="color: red">{{ defendantError }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="row"
                                                         style="margin: 0; padding: 0 0 0.5em">
                                                        <div
                                                                class="col-md-24"
                                                                style="padding-left: 0; padding-right: 0">
                                                            <div class="input-group-sm">
                                                                <small>
                                                                    <b><i>
                                                                        Nombre(s)
                                                                        <span style="color: red">*</span>
                                                                    </i></b>
                                                                </small>
                                                                <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="Nombre(s)"
                                                                        v-model="defendantCompany.name">
                                                            </div>
                                                        </div>
                                                        <button
                                                                class="btn-sm btn-primary"
                                                                type="button"
                                                                style="margin-top: 1em; width: 100%"
                                                                @click="addDefendantCompany">
                                                            Agregar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row" v-if="defendants != ''">
                                            <div class="col-md-24">
                                                <div class="panel panel-default" style="font-size: 0.8em">
                                                    <div class="panel-heading">Demandados</div>
                                                    <table class="table table-striped">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Nombre</th>
                                                            <th class="text-center">Acciones</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(defendant, index) in defendants">
                                                            <th scope="row">{{ index + 1}}</th>
                                                            <td>
                                                                {{ defendant.name }}
                                                                {{ defendant.firstName != '' ? defendant.firstName : ''
                                                                }}
                                                                {{ defendant.secondName != '' ? defendant.secondName :
                                                                '' }}
                                                            </td>
                                                            <td class="text-center">
                                                            <span
                                                                    class="glyphicon glyphicon-trash"
                                                                    aria-hidden="true"
                                                                    style="color: red"
                                                                    @click="removeDefendant(index)">
                                                            </span>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>-->
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label style="margin-top: 0.5em">
                                            Número de expediente del juzgado
                                            <span style="color: red">*</span>
                                        </label>
                                        <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Ingrese en número de expediente"
                                                v-model="courtRecord">
                                    </div>
                                </div>
                                <p style="color: red" v-if="showMessage">
                                    <small>{{ errorMessagee }}</small>
                                </p>
                            </div>
                            <div class="col-md-12">
                                <button
                                        class="btn btn-default"
                                        type="button"
                                        @click="getCaseStatus"
                                        style="margin-top: 1em">
                                    <i class="fa fa-search"></i>
                                    Buscar
                                </button>
                                <button
                                        class="btn btn-primary"
                                        type="button"
                                        @click="downloadDocument(1)"
                                        style="margin-top: 1em">
                                    <i class="fa fa-download"></i>
                                    Información de Exhortos
                                </button>
                                <button
                                        class="btn btn-primary"
                                        type="button"
                                        @click="downloadDocument(2)"
                                        style="margin-top: 1em">
                                    <i class="fa fa-download"></i>
                                    Anexo al Protocolo Adicional a la Convención Interamericana
                                </button>
                                <button
                                        class="btn btn-primary"
                                        type="button"
                                        @click="downloadDocument(3)"
                                        style="margin-top: 1em">
                                    <i class="fa fa-download"></i>
                                    Documento Unificado
                                </button>
                            </div>
                        </div>
                        <div
                                class="row"
                                v-if="caseStatusFound">
                            <div class="col-md-12" style="margin-top: 40px !important;">
                                <div class="col-md-12">
                                    <div class="alert alert-success" role="alert">
                                        A continuación se muestra la información del expediente.
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="panel panel-primary">
                                        <div class="panel-heading">
                                            <h3 class="panel-title">Estatus de expediente</h3>
                                        </div>
                                        <div class="panel-body">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <h5>Número</h5>
                                                    <p>{{ courtRecord }}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <h5>Español</h5>
                                                    <p>{{ caseStatus }}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <h5>English</h5>
                                                    <p>{{ caseStatusEn }}</p>
                                                </div>
                                                <div class="col-md-3">
                                                    <h5>Français</h5>
                                                    <p>{{ caseStatusFr }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button
                                            type="button"
                                            class="btn btn-link"
                                            style="padding: 0"
                                            @click="newSearch">
                                        &#8634; Realizar una nueva consulta
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </section>
        <div style="bottom: 5%; right: 5%; position: fixed; opacity: .5">
            <span>SICRE Consulta Web <sup>{{version}}</sup></span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // Tabs
                version: '',
                applicantTab: true,
                defendantTab: true,
                // Applicants and defendants
                applicants: [],
                defendants: [],
                caseStatusFound: false,
                courtRecord: null,
                applicantPerson: {
                    name: null,
                    firstName: null,
                    secondName: null,
                    applicantType: 1,
                },
                applicantCompany: {
                    name: null,
                    applicantType: 2
                },
                defendantPerson: {
                    name: null,
                    firstName: null,
                    secondName: null,
                    applicantType: 1
                },
                defendantCompany: {
                    name: null,
                    applicantType: 2
                },
                applicantError: null,
                defendantError: null,
                // Status
                caseStatus: null,
                caseStatusEn: null,
                caseStatusFr: null,
                showMessage: false,
                errorMessagee: '',
            }
        },

        created(){
          this.version = window.versionApp
        },

        methods: {
            getCaseStatus() {
                this.showMessage = false;
                if (this.courtRecord != null && this.applicants != '' /*&& this.defendants != ''*/) {
                    axios.post('/c/get-status', {
                        courtRecord: this.courtRecord,
                        applicants: this.applicants,
                        defendants: this.defendants
                    }).then(response => {
                        if (response.data.success == true) {
                            this.caseStatusFound = true;
                            this.courtRecord = response.data.expedient;
                            this.caseStatus = response.data.webStatus != '' ? response.data.webStatus : 'Aún no hay información disponible sobre el estatus del expediente. Inténtelo más tarde.';
                            this.caseStatusEn = response.data.webStatusEn != '' ? response.data.webStatusEn : 'There is not information.';
                            this.caseStatusFr = response.data.webStatusFr != '' ? response.data.webStatusFr : "Pas d'informatio.";
                        } else {
                            this.showMessage = true;
                            this.errorMessagee = "No se encontro ningún expediente con la información proporcionada.";
                        }
                    });
                } else {
                    this.showMessage = true;
                    this.errorMessagee = "Proporcione el número de expediente e indique actor(es) y demandado(s)";
                }
            },
            newSearch() {
                this.caseStatusFound = false;
                this.courtRecord = null;
                this.applicants = [];
                this.defendants = [];
                this.caseStatus = null;
                this.showMessage = false;
            },
            addApplicantPerson() {
                if (this.applicantPerson.name == null ||
                    this.applicantPerson.firstName == null) {
                    this.applicantError = 'Complete los campos requeridos.';
                } else {
                    this.applicants.push({
                        name: this.applicantPerson.name,
                        firstName: this.applicantPerson.firstName,
                        secondName: this.applicantPerson.secondName,
                        applicantType: this.applicantPerson.applicantType
                    });
                    this.applicantPerson.name = null;
                    this.applicantPerson.firstName = null;
                    this.applicantPerson.secondName = null;
                    this.applicantError = null;
                }
            },
            addApplicantCompany() {
                if (this.applicantCompany.name == null) {
                    this.applicantError = 'Complete los campos requeridos.';
                } else {
                    this.applicants.push({
                        name: this.applicantCompany.name,
                        applicantType: this.applicantCompany.applicantType
                    });
                    this.applicantCompany.name = null;
                    this.applicantError = null;
                }
            },
            addDefendantPerson() {
                if (this.defendantPerson.name == null ||
                    this.defendantPerson.firstName == null) {
                    this.defendantError = 'Complete los campos requeridos.';
                } else {
                    this.defendants.push({
                        name: this.defendantPerson.name,
                        firstName: this.defendantPerson.firstName,
                        secondName: this.defendantPerson.secondName,
                        applicantType: this.defendantPerson.applicantType
                    });
                    this.defendantPerson.name = null;
                    this.defendantPerson.firstName = null;
                    this.defendantPerson.secondName = null;
                    this.defendantError = null;
                }
            },
            addDefendantCompany() {
                if (this.defendantCompany.name == null) {
                    this.defendantError = 'Complete los campos requeridos.';
                } else {
                    this.defendants.push({
                        name: this.defendantCompany.name,
                        applicantType: this.defendantCompany.applicantType
                    });
                    this.defendantCompany.name = null;
                    this.defendantError = null;
                }
            },
            removeApplicant(applicanttIndex) {
                this.applicants.splice(applicanttIndex, 1);
            },
            removeDefendant(defendantIndex) {
                this.defendants.splice(defendantIndex, 1);
            },

            downloadDocument(type) {
                if (type == 1) {
                    var a = document.createElement('a');
                    a.target = "_blank";
                    a.href = "/docs/INFORMACION DE EXHORTOS O CARTAS ROGATORIAS (INTERNET).pdf";
                    a.click();
                } else if (type == 2) {
                    var a = document.createElement('a');
                    a.target = "_blank";
                    a.href = "/docs/ANEXO AL PROTOCOLO ADICIONAL.pdf";
                    a.click();
                } else if (type == 3) {
                    var a = document.createElement('a');
                    a.target = "_blank";
                    a.href = "/docs/formula modelo-DOCUMENTO UNIFICADO.pdf";
                    a.click();
                }
            }
        }
    }
</script>

<style>
    body {
        margin: 0;
        padding: 0;
        padding-top: 46px;
    }

    main {
        background-color: white;
    }

    .custom-container {
        margin-bottom: 40px;
    }

    .navbar-brand-custom {
        background-color: #f6f6f6 !important;
        color: #000 !important;
        font-size: 16px !important;
    }

    .navbar-brand-custom:hover {
        background-color: #000 !important;
        color: #fff !important;
    }

    /*	@import 'https://framework-gb.cdn.gob.mx/assets/styles/main.css';*/
</style>
